import { PLAY_PRODUCT } from './productsList';

export const COMPANY_GROUPS_LIST = [
  {
    id: 'g_ko2BK',
    name: 'Development',
    createdAt: 1644256455431,
    updatedAt: 1644256455431,
    users: [
      {
        id: 'u_ko2BK',
        createdAt: 1644256455431,
        updatedAt: 1644256455431,
        lastLogin: 1644256455431,
        companies: [
          {
            id: 'c_ko2BK',
            name: 'Craftsman+',
            logo: '',
          },
        ],
        groups: [
          {
            id: 'g_ko2BK',
            name: 'Development',
          },
        ],
        licenses: [
          {
            id: 'l_ko2BK',
            totalUsers: 2,
            trial: false,
            seats: 10,
            durationLength: 30,
            durationType: 'months',
            startDate: 1644256455431,
            isEnabled: true,
            product: PLAY_PRODUCT,
          },
        ],
        email: 'camilo.garcia@craftsmanplus.com',
        firstName: 'Camilo',
        lastName: 'Garcia',
        isEmailConfirmed: false,
        isEnabled: true,
        jobTitle: 'Fancy Pants',
        phone: '+97334795153',
        roles: [
          {
            id: 1,
            name: 'system-admin',
          },
        ],
        permissions: [
          'creative:read',
          'creative:edit',
        ],
      },
      {
        id: 'u_ko2BK1',
        createdAt: 1644256455431,
        updatedAt: 1644256455431,
        lastLogin: 1649139600000,
        companies: [
          {
            id: 'c_ko2BK',
            name: 'Craftsman+',
            logo: '',
          },
        ],
        groups: [
          {
            id: 'g_ko2BK',
            name: 'Development',
          },
        ],
        licenses: [
          {
            id: 'l_ko2BK',
            totalUsers: 2,
            trial: false,
            seats: 10,
            durationLength: 30,
            durationType: 'days',
            startDate: 1644256455431,
            isEnabled: false,
            product: PLAY_PRODUCT,
          },
        ],
        email: 'alan.parsons@craftsmanplus.com',
        firstName: 'Alan',
        lastName: 'Parsons',
        isEmailConfirmed: false,
        isEnabled: true,
        jobTitle: 'Fancy Pants',
        phone: '+97334795153',
        roles: [
          {
            id: 1,
            name: 'system-admin',
          },
        ],
        permissions: [
          'creative:read',
          'creative:edit',
        ],
      },
    ],
  },
  {
    id: 'g_ko2BK1',
    name: 'Management',
    createdAt: 1644256455431,
    updatedAt: 1644256455431,
    users: [
      {
        id: 'u_ko2BK2',
        createdAt: 1644256455431,
        updatedAt: 1644256455431,
        lastLogin: 1650003655431,
        companies: [
          {
            id: 'c_ko2BK',
            name: 'Craftsman+',
            logo: '',
          },
        ],
        groups: [
          {
            id: 'g_ko2BK1',
            name: 'Management',
          },
        ],
        licenses: [],
        email: 'richard.stephens@craftsmanplus.com',
        firstName: 'Richard',
        lastName: 'Stephens',
        isEmailConfirmed: false,
        isEnabled: true,
        jobTitle: 'Fancy Pants',
        phone: '+97334795153',
        roles: [
          {
            id: 1,
            name: 'system-admin',
          },
        ],
        permissions: [
          'creative:read',
          'creative:edit',
        ],
      },
    ],
  },
];

export const DELETED_COMPANY_GROUP_LIST = [
  {
    id: 'd_ko2BK',
    name: 'Deleted group',
    createdAt: 1644256455431,
    updatedAt: 1644256455431,
    users: [],
  },
];

export default COMPANY_GROUPS_LIST;
